import { type ComponentProps } from 'react'
import { twMerge } from 'tailwind-merge'

interface LoadingStateSpinnerProps extends ComponentProps<'div'> {
  className?: string
}

function LoadingStateSpinner({ className, ...props }: LoadingStateSpinnerProps) {
  return (
    <div
      className={twMerge('border-border border-t-foreground size-4 animate-spin rounded-full border-2', className)}
      {...props}
    />
  )
}

export { LoadingStateSpinner }
